<script setup>
// Aparece só em inbox Cloud API com chamadas ligadas. Se a Meta recusar a
// ligação (sem permissão, tier, etc.), o botão vira "pedir permissão".
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import NextButton from 'dashboard/components-next/button/Button.vue';
import WhatsappCallsAPI from 'dashboard/api/whatsappCalls';
import { useWhatsappCallsStore } from 'dashboard/stores/whatsappCalls';
import { startCall } from 'dashboard/helper/whatsappCall/session';

const props = defineProps({
  chat: { type: Object, default: () => ({}) },
});

const { t } = useI18n();
const store = useStore();
const calls = useWhatsappCallsStore();
const busy = ref(false);

const inbox = computed(() =>
  store.getters['inboxes/getInbox'](props.chat.inbox_id)
);
const visible = computed(
  () =>
    inbox.value?.channel_type === 'Channel::Whatsapp' &&
    inbox.value?.provider === 'whatsapp_cloud' &&
    inbox.value?.calling_enabled &&
    props.chat.id
);
const needsPermission = computed(() => calls.permissionNeeded[props.chat.id]);
const inCall = computed(() => calls.active !== null);

const call = async () => {
  busy.value = true;
  try {
    await startCall({
      conversationId: props.chat.id,
      contactName: props.chat.meta?.sender?.name,
    });
  } catch (error) {
    const data = error?.response?.data;
    if (data?.error === 'call_failed')
      calls.setPermissionNeeded(props.chat.id, true);
    useAlert(data?.message || t('CONVERSATION.WHATSAPP_CALL.MIC_ERROR'));
  } finally {
    busy.value = false;
  }
};

const askPermission = async () => {
  busy.value = true;
  try {
    await WhatsappCallsAPI.permissionRequest(props.chat.id);
    calls.setPermissionNeeded(props.chat.id, false);
    useAlert(t('CONVERSATION.WHATSAPP_CALL.PERMISSION_SENT'));
  } catch (error) {
    useAlert(
      error?.response?.data?.message ||
        t('CONVERSATION.WHATSAPP_CALL.MIC_ERROR')
    );
  } finally {
    busy.value = false;
  }
};
</script>

<template>
  <NextButton
    v-if="visible && needsPermission"
    sm
    faded
    slate
    icon="i-ph-phone-call"
    :label="$t('CONVERSATION.WHATSAPP_CALL.REQUEST_PERMISSION')"
    :is-loading="busy"
    @click="askPermission"
  />
  <NextButton
    v-else-if="visible"
    sm
    teal
    icon="i-ph-phone"
    :label="$t('CONVERSATION.WHATSAPP_CALL.CALL')"
    :is-loading="busy"
    :disabled="inCall"
    @click="call"
  />
</template>
